import React, { useState } from "react";

import { InspectorContextProvider } from "contexts/Inspector";
import Selection8People from "./Selection8People";

const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "Selection8People",
    props: null
  });

  return (
    <InspectorContextProvider>
      <SwitchComponents active={pageProps.active}>
        <Selection8People
          name="Selection8People"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </InspectorContextProvider>
  );
};

export default Index;
